/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";

export const FlagsPermissionKulioner = {
  permission_kulioner_enable: new Rox.Flag(true),
  permission_kulioner_detail_view: new Rox.Flag(true)
};

export function initFlagsPermissionKulioner() {
  // register flags with namespaces for better grouping
  Rox.register("featureKulioner", FlagsPermissionKulioner);
}
